<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :module_name="page.name"/>
    <v-row>
      <v-col>
        <base-table ref="base_table" :page="page" @create="create" @edit="edit"/>
      </v-col>
    </v-row>
    <create-tag ref="create_tag" modal_name="create_tag" @refresh="reload"/>
    <edit-tag ref="edit_tag" modal_name="edit_tag" @refresh="reload"/>
  </v-container>
</template>

<script>
import CreateTag from "./Create";
import EditTag from "./Edit";
import BaseTable from "../../components/commonComponents/BaseTable";
import BaseBreadcrumb from "../../components/commonComponents/BaseBreadcrumb";
export default {
  components: {
    BaseTable,
    CreateTag,
    EditTag,
    BaseBreadcrumb,
  },
  data() {
    return {
      page: {
        title: this.$store.getters.translate("tags"),
        name: "tags",
        model: "tag",
      },
    };
  },
  methods: {
    create() {
      this.$refs.create_tag.openModal('create_tag');
    },
    edit(item) {
      this.$refs.edit_tag.load(item.id);
    },
    reload() {
      this.$refs.base_table.run();
    },
  },
};
</script>
